import {makeActionCreator} from '../utility'

export const SUBMIT_FIRM_APPLICATION = 'SUBMIT_FIRM_APPLICATION'
export const submitFirmApplication = makeActionCreator(SUBMIT_FIRM_APPLICATION,'data')

export const SUBMIT_FIRM_APPLICATION_SUCCESSFUL = 'SUBMIT_FIRM_APPLICATION_SUCCESSFUL'
export const submitFirmApplicationSuccessful = makeActionCreator(SUBMIT_FIRM_APPLICATION_SUCCESSFUL, 'data')

export const FETCH_FIRM_APPLICATION = 'FETCH_FIRM_APPLICATION'
export const fetchFirmApplication = makeActionCreator(FETCH_FIRM_APPLICATION, 'data')

export const FETCH_FIRM_APPLICATION_RECEIVED = 'FETCH_FIRM_APPLICATION_RECEIVED'
export const fetchFirmApplicationReceived = makeActionCreator(FETCH_FIRM_APPLICATION_RECEIVED, 'data')


export const UPDATE_FIRM_APPLICATION = 'UPDATE_FIRM_APPLICATION'
export const updateFirmApplication = makeActionCreator(UPDATE_FIRM_APPLICATION, 'data')


export const FIRM_APPLICATION_UPDATED = 'FIRM_APPLICATION_UPDATED'
export const firmApplicantUpdated = makeActionCreator(FIRM_APPLICATION_UPDATED, 'data')


export const FETCH_FIRM_APPLICATION_STATUS = 'FETCH_FIRM_APPLICATION_STATUS'
export const fetchFirmApplicationStatus = makeActionCreator(FETCH_FIRM_APPLICATION_STATUS, 'data')


export const FIRM_APPLICATION_STATUS_RECEIVED = 'FIRM_APPLICATION_STATUS_RECEIVED'
export const FirmApplicationStatusReceived = makeActionCreator(FIRM_APPLICATION_STATUS_RECEIVED, 'data')